const PREFIX = "part-finder-tracker";

export const ROUTER_LOCATION_CHANGE = "@@router/LOCATION_CHANGE";
export const TRACK_PRODUCT_VIEW = `${PREFIX}/TRACK_PRODUCT_VIEW`;
export const TRACK_LINK = `${PREFIX}/TRACK_LINK`;

export function trackProductView(material) {
  return {
    type: TRACK_PRODUCT_VIEW,
    payload: material,
  };
}

export function trackLink(url, linkType) {
  return {
    type: TRACK_LINK,
    payload: { url, linkType },
  };
}
